// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__GWZaE","modelWrapper":"Modal_modelWrapper__CcWZF","modal":"Modal_modal__AElSz","modalClose":"Modal_modalClose__qwqsE","modalBody":"Modal_modalBody__1q6Ya"};